export default __webpack_public_path__ + "static/dum_2-6d851f226323a1bca011f11721e9beda.webp";